/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalProcedureItem from './hospital-procedure-item';
import HospitalProcedureItemDetail from './hospital-procedure-item-detail';
import HospitalProcedureItemUpdate from './hospital-procedure-item-update';
import HospitalProcedureItemDeleteDialog from './hospital-procedure-item-delete-dialog';

const HospitalProcedureItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalProcedureItem />} />
    <Route path="new" element={<HospitalProcedureItemUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalProcedureItemDetail />} />
      <Route path="edit" element={<HospitalProcedureItemUpdate />} />
      <Route path="delete" element={<HospitalProcedureItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalProcedureItemRoutes;
